import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { Router, RouterLink } from '@angular/router'

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

import {
  KpiDashboardService,
  KpiDashboardSummary,
} from '../../../services/kpi-dashboard/kpi-dashboard.service'
import { captureException } from '../../../util/captureException'

@UntilDestroy()
@Component({
  selector: 'app-kpi-dashboard-list',
  standalone: true,
  imports: [MatCardModule, MatIconModule, MatProgressSpinnerModule, RouterLink],
  templateUrl: './kpi-dashboard-list.component.html',
  styleUrl: './kpi-dashboard-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiDashboardListComponent implements OnInit {
  dashboards: KpiDashboardSummary[] = []
  isLoading = true
  loadFailed = false

  constructor(
    private kpiDashboardService: KpiDashboardService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.kpiDashboardService
      .dashboards()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (dashboards) => {
          this.dashboards = dashboards
          this.isLoading = false

          if (dashboards.length === 1) {
            this.router.navigate(['/kpi-dashboards', dashboards[0].id], {
              replaceUrl: true,
            })
          }

          this.changeDetectorRef.markForCheck()
        },
        error: (error: unknown) => {
          captureException(error)
          this.isLoading = false
          this.loadFailed = true
          this.changeDetectorRef.markForCheck()
        },
      })
  }
}
